import Button from "../CustomButton/CustomButton";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import React from "react";

function NewButton({ newRecordUrl, ...others }) {
  return (
    <Link className="full-width" to={newRecordUrl}>
      <Button {...others} icon wd bsStyle="primary">
        <i className="fa fa-lg fa-plus-circle margin-right-5" />
        <FormattedMessage id="ids_new" />
      </Button>
    </Link>
  );
}

export { NewButton };
